
import { default as UtilsLanguage } from './utils.Language';

export default class UtilsMetadata {

  static getMetadataValuesByID(metadata, metaID) {
    var element = metadata.find(function(meta) { return meta.ID.toLowerCase() === metaID.toLowerCase()});
    if (!element)
      return "";

    if (typeof(element.Values) !== 'undefined' && typeof(element.Values[0]) !== 'undefined')
      return element.Values[0];
    else if (typeof(element.LocalizedValues) !== 'undefined' && typeof(element.LocalizedValues[0]) !== 'undefined') {
      if (typeof(element.LocalizedValues[0].Values) !== 'undefined' && typeof(element.LocalizedValues[0].Values[0]) !== 'undefined')
        return element.LocalizedValues[0].Values[0];
      else
        return "";
    }
    else
      return "";
  }

  static getMetadataValues(metadata, metaID) {
    return metadata.find((meta) => { return meta.ID.toLowerCase() === metaID.toLowerCase();}) ? metadata.find((meta) => { return meta.ID.toLowerCase() === metaID.toLowerCase();}).Values[0] : null;
  }

  static getMetadataFirstValueByID(metadata, metaID) {
    return UtilsMetadata.getMetadataValuesByID(metadata, metaID).length > 0 ? UtilsMetadata.getMetadataValuesByID(metadata, metaID)[0] : "";
  }

  static getMetadataValuesByIDFrontEnd(metadata, metaID) {
    var localizedItems = metadata.Values.filter((e) => { return e.Language == UtilsLanguage.getUserLanguage() });
    if (localizedItems.length == 0)
      localizedItems = metadata.Values[0].Items;
    else
      localizedItems = localizedItems[0].Items;

    return localizedItems.find((e) => { return e.ID == metaID}) ? localizedItems.find((e) => { return e.ID == metaID}).Values : "";
  }

  static getMetadataFirstValueByIDFrontEnd(metadata, metaID) {
    return UtilsMetadata.getMetadataValuesByIDFrontEnd(metadata, metaID).length > 0 ? UtilsMetadata.getMetadataValuesByIDFrontEnd(metadata, metaID)[0] : "";
  }
}
